import { useTranslation } from 'react-i18next'
import { Text } from '@asus-common/fe-ui-shadcn'

export function InternalInfoStep() {
  const { t } = useTranslation('reset-password')

  return (
    <Text className="mt-6 block" fontSize="md" variant="secondary">
      {t('modal.internal_reset_info')}
    </Text>
  )
}
